<template>
  <div class="wrapper page-contact">
    <transition name="fade" mode="out-in">
      <video-bg :sources="[sourcesToVbg[currentNumber]]" :img="sourcesToImg[currentNumber]" id="video-bg"></video-bg>
    </transition>
    <div class="information">
      <div class="contact-text">{{ $t('message.contact_text[' + currentNumber + ']') }}</div>
      <span class="separator"></span>
      <div class="contact-text-portfolio">{{ $t('message.contact_text_portfolio') }} 
        <a href="mailto:design@saatchiis.pl" class="mail" v-if="currentNumber === 0">design@saatchiis.pl</a>
        <a href="mailto:creative@saatchiis.pl" class="mail mail-creative" v-if="currentNumber === 1">creative@saatchiis.pl</a>
      </div>
    </div>
    
    <footer class='footer-page-contact'>
        <span class="separator-contact" :class="{blue: currentNumber === 1}"></span>
        <a href="http://saatchiis.pl" class="company-name-contact" alt="" target="_blank" :class="{blue: currentNumber === 1}">Saatchi&#38;saatchi is</a>
        <span class="separator-contact" :class="{blue: currentNumber === 1}"></span>
    </footer>


  </div>
</template>
<script>
  import { EventBus } from '../main.js';

  export default {
    props: ['currentPage'],
    data: () => ({
      currentNumber: 0,
      sourcesToVbg: [
        '../../assets/video/background_2.mp4',
        '../../assets/video/loop_mail.mp4'
      ],
      sourcesToImg:[
        '../../assets/img/mail-bg.jpg',
        '../../assets/img/mail-creative.jpg'
      ]
    }),
    created() {
      if(this.currentPage === "creative") {
        this.currentNumber = 1;
      }
    }
  }

</script>

<style type="text/css">
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
  .information {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: #a2a2a2;
    width: 100%;
  }
  .information .contact-text {
    font-size: 21px;
    max-width: 860px;
    margin: 0 auto;
    margin-bottom: 3.5%;
  }

  .information .contact-text-portfolio {
    font-size: 18px;
    margin-top: 3%;
  }

  .information .separator{
    display: block;
    width: 82px;
    height: 1px;
    background: #a2a2a2;
    margin: 0 auto;
    text-align: center;
  }
  
  .information .contact-text-portfolio .mail {
    color: #998551;
    display: inline-block;
    text-decoration: none;
    cursor: pointer;
  }

  .information .contact-text-portfolio .mail.mail-creative {
    color: #96bbf6;
  }
  
  .footer-page-contact {
    position: fixed;
    bottom: 6.5%;
    text-transform: uppercase;
    text-align: center;
    width: 100%;
    
    display: -webkit-box; 
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex; 
    -webkit-box-align: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }
  .footer-page-contact .company-name-contact{
    color: #998551;
    font-size: 11px;
    letter-spacing: 6px;
    width: 377px;
    min-width: 377px;
    display: block;
    text-decoration: none;
    cursor: pointer;
  }
  .footer-page-contact .company-name-contact.blue {
    color: #96bbf6;
  }

  .footer-page-contact .separator-contact {
    height: 2px;
    width: 100%;
    background: #998551;
  }

  .footer-page-contact .separator-contact.blue {
    background: #96bbf6;
  }

  @media(min-width: 768px) {
    .information .contact-text {
      font-size: 32px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/contact.vue